module.exports = __webpack_public_path__ + "static/media/usa_3.f15ce36b.jpg";